import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center">
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 bg-gradient-primary rounded-2xl flex items-center justify-center shadow-elevated">
          <Icon name="Newspaper" size={32} color="white" />
        </div>
      </div>
      <h2 className="text-3xl font-heading font-bold text-foreground">
        Welcome back
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Sign in to access your journalism tools
      </p>
    </div>
  );
};

export default LoginHeader;